export const HttpStatus = {
    OK: 200,
    MultiStatus: 207,

    BadRequest: 400,
    Conflict: 409,
    NotFound: 404,
    UnprocessableEntity: 422,

    InternalServer: 500
} 
